import ProfilsController from './profils.controller';

export default {
    template: require('./profils.tpl.html'),
    controller: ProfilsController
};
